import { Injectable, inject } from '@angular/core';
import { SettingsService } from './../http/settings.service';
import { GlobalSettingDao } from './../models/settings/global-setting-dao.model';
import { SessionStoreService } from './session-store.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingService {
  private _settingsService = inject(SettingsService);
  private _sessionStoreService = inject(SessionStoreService);

  public get settings(): GlobalSettingDao | null {
    return this._sessionStoreService.getData<GlobalSettingDao>('globalSettings');
  }

  public async loadSettings(): Promise<GlobalSettingDao> {
    return await this._settingsService.loadGlobalSettings().then((globalSettings) => {
      const globalSettingsDao = new GlobalSettingDao(globalSettings);
      this._sessionStoreService.setData('globalSettings', globalSettingsDao);
      return globalSettingsDao;
    });
  }
}
